import React from "react";
import { useInView } from "react-intersection-observer";
import "../styles/Contacthero.css";
import teamImg from "../assets/applynow.jpeg";
import parallaxImg from "../assets/bg9.jpeg";

const Contacthero = () => {
  const [box1Ref, box1InView] = useInView({ triggerOnce: true, threshold: 0.5 });
  const [box2Ref, box2InView] = useInView({ triggerOnce: true, threshold: 0.5 });
  const [detailRef, detailInView] = useInView({ triggerOnce: true, threshold: 0.4 });
  const [addressRef, addressInView] = useInView({ triggerOnce: true, threshold: 0.4 });
  const [mapRef, mapInView] = useInView({ triggerOnce: true, threshold: 0.4 });

  return (
    <div className="contacthero-container">
      <div className="contacthero-header">
        <h1>CAREERS</h1>
      </div>

      <div className="contacthero-boxes">
        <div
          ref={box1Ref}
          className={`contacthero-box ${box1InView ? "animate-fadeUp" : ""}`}
        >
          <h2>Join Our Team</h2>
          <p>
            Be a part of a forward-thinking company that values innovation,
            dedication, and personal growth.
          </p>
          <div className="contacthero-layer">
            <span>Open positions available worldwide</span>
          </div>
        </div>

        <div
          ref={box2Ref}
          className={`contacthero-box ${box2InView ? "animate-fadeUp" : ""}`}
        >
          <h2>Why Work With Us</h2>
          <p>
            We offer a dynamic workplace, opportunities to grow, and an inclusive
            culture where everyone matters.
          </p>
          <div className="contacthero-layer">
            <span>Flexible hours and remote options</span>
          </div>
        </div>
      </div>

      <div
        ref={detailRef}
        className={`contacthero-detail ${detailInView ? "animate-fadeUp" : ""}`}
      >
        <div className="contacthero-text">
          <h2>Build Your Future With Us</h2>
          <p>
            Our culture is built on trust, innovation, and respect. Whether you're
            just starting out or looking to take your career to the next level, we
            provide the tools and opportunities to grow.
          </p>
        </div>
        <div className="contacthero-image">
          <img src={teamImg} alt="Our Team" />
        </div>
      </div>

      <div
        className="contacthero-parallax-section"
        style={{ backgroundImage: `url(${parallaxImg})` }}
      />

      <div
        ref={addressRef}
        className={`contacthero-addresses ${addressInView ? "animate-fadeUp" : ""}`}
      >
       <div className="contacthero-address-box">
          <h3>India Office</h3>
          <p>
             APEXCEL TRADING AND SERVICES PRIVATE LIMITED<br />
            NO:69, SHANTHI NAGAR 2nd STREET, VEDHANARAYANAPURAM,<br />
           CHENGALPATTU - 603111,<br />
            TAMILNADU, INDIA.<br />
            Email: <a href="mailto:hr@apexcel.in">hr@apexcel.in</a><br />
            Mobile:+91 8925288802
          </p>
        </div>

        <div className="contacthero-address-box">
          <h3>Dubai Office</h3>
          <p>
            APEXCEL ELECTROMECHANICAL WORKS L.L.C<br />
            P.O.Box : 238688,<br />
            DUBAI,<br />
            UAE.<br />
            Email: <a href="mailto:services@apexcel.ae">services@apexcel.ae</a><br />
            Mobile: +971 528 368 328
          </p>
        </div>

        <div className="contacthero-address-box">
          <h3>Abu Dhabi Office</h3>
          <p>
            APEXCEL ELECTROMECHANICAL WORKS<br />
            {/* P.O.Box : 238688,<br /> */}
            Abu Dhabi,<br />
            UAE.<br />
            Email: <a href="mailto:services@apexcel.ae">services@apexcel.ae</a><br />
            Mobile: +971 528 368 328
          </p>
        </div>
      </div>

      {/* Two Maps Side by Side */}
      <div
        ref={mapRef}
        className={`contacthero-map-wrapper ${mapInView ? "animate-fadeUp" : ""}`}
      >
        <div className="contacthero-map-box">
          <iframe src="https://www.google.com/maps/embed?pb=!1m21!1m12!1m3!1d299.380487621387!2d79.96712275403527!3d12.65477391227394!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!4m6!3e6!4m0!4m3!3m2!1d12.654840974226143!2d79.96705167549992!5e1!3m2!1sen!2sin!4v1747723482513!5m2!1sen!2sin" width="100%" height="100%" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>        
        </div>
        <div className="contacthero-map-box">
          <iframe src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d4476.333565427988!2d55.3873056!3d25.29175!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjXCsDE3JzMwLjMiTiA1NcKwMjMnMTQuMyJF!5e1!3m2!1sen!2sin!4v1747308529372!5m2!1sen!2sin" width="100%" height="100%" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>         
        </div>
        <div className="contacthero-map-box">
          <iframe src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d4510.229895276342!2d54.487144475354846!3d24.357398978261052!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjTCsDIxJzI2LjYiTiA1NMKwMjknMjMuMCJF!5e1!3m2!1sen!2sin!4v1747373132960!5m2!1sen!2sin" width="100%" height="100%" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
        </div>
      </div>
    </div>
  );
};

export default Contacthero;
